import { defineStore } from "pinia";
import http from "@/http";
import { LIST_PROFISSIONAL, ADD_PROFISSIONAL, UPDATE_PROFISSIONAL, DEL_PROFISSIONAL } from "@/http/url";

export const useProfissionalStore = defineStore("ProfissionalStore", {
  state: () => {
    return {
      profissionais: [],
      loaded: false,
    };
  },
  
  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    LISTAR_PROFISSIONAIS() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_PROFISSIONAL)
          .then((response) => {
            this.profissionais = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_PROFISSIONAL(profissional) {
      return http
        .post(ADD_PROFISSIONAL, profissional)
        .then((response) => this.profissionais.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_PROFISSIONAL(profissional) {
      return http.put(`${UPDATE_PROFISSIONAL + profissional.id}`, profissional);
    },

    REMOVER_PROFISSIONAL(id) {
      return http
        .delete(`${DEL_PROFISSIONAL + id}`)
        .then(() => (this.profissionais = this.profissionais.filter((p) => p.id != id)));
    },

  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getProfissionais() {      
      return this.profissionais;
    },

    getProfissionalLoad(state) {
      return state.loaded;
    },

    getFilterProfissionais: (state) => {
      return (filtro) => state.profissionais.filter((p) => !filtro || p.nome.includes(filtro));
    },
  },
});